import React from "react";
import classes from './Divider.module.scss'

const Divider = ({backgroundColor}:any) => {
    return(
        <div className={backgroundColor ? classes.containerTransperant : classes.container}></div>
    )
}

export default Divider;